import script from "./SecDomainGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./SecDomainGrid.vue?vue&type=script&setup=true&lang=js"

import "./SecDomainGrid.vue?vue&type=style&index=0&id=17f75d94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f75d94"]])

export default __exports__